/**
* DevExpress HTML/JS Reporting (designer\wizard\internal\utils.js)
* Version:  24.1.7
* Build date: Oct 28, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { _DataSourceWizardOptionsBase } from '@devexpress/analytics-core/analytics-wizard';
import { ReportWizardSettings } from '../../utils/inititalizer';
export class _ReportWizardOptions extends _DataSourceWizardOptionsBase {
    constructor() {
        super(...arguments);
        this.wizardSettings = new ReportWizardSettings().createDefault();
        this.hideDataMemberSubItems = false;
    }
}
